// Функция для форматирования чисел с максимум N знаками после запятой (без лишних нулей)
export const formatNumber = (num, decimals = 2) => {
  if (num === null || num === undefined) return '0';

  // Преобразуем в число
  const number = parseFloat(num);

  // Если NaN или Infinity
  if (!isFinite(number)) return '0';

  // Если число целое, возвращаем без десятичной части
  if (Number.isInteger(number)) {
    return number.toLocaleString('ru-RU');
  }

  // Если есть дробная часть, показываем максимум decimals знаков (без лишних нулей)
  return number.toLocaleString('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals
  });
};

// Функция для форматирования чисел без лишних нулей (30.00 → 30, 30.50 → 30.5)
export const formatClean = (num, maxDecimals = 4) => {
  if (num === null || num === undefined) return '0';
  const number = parseFloat(num);
  if (!isFinite(number)) return '0';

  // Округляем до maxDecimals знаков и убираем trailing zeros
  const fixed = number.toFixed(maxDecimals);
  return parseFloat(fixed).toString();
};

// Функция для форматирования цены (адаптивная точность)
export const formatPrice = (num) => {
  if (num === null || num === undefined) return '0';
  const number = parseFloat(num);
  if (!isFinite(number)) return '0';

  // Для очень маленьких чисел - больше знаков
  if (Math.abs(number) < 0.0001) return number.toFixed(8);
  if (Math.abs(number) < 0.01) return number.toFixed(6);
  if (Math.abs(number) < 1) return number.toFixed(4);

  // Для больших чисел - меньше знаков
  return formatNumber(number, 2);
};

// Функция для форматирования валюты (SPERM)
export const formatCurrency = (amount, symbol = 'SPERM') => {
  const formatted = formatNumber(amount, 2);
  return `${formatted} ${symbol}`;
};

// Функция для форматирования процентов
export const formatPercent = (percent) => {
  const formatted = formatNumber(percent, 2);
  return `${formatted}%`;
};

// Вспомогательная функция для безопасного парсинга даты
const parseDate = (date) => {
  if (!date) return null;
  const d = new Date(date);
  return isNaN(d.getTime()) ? null : d;
};

// Вспомогательная функция для форматирования компонентов даты в МСК
const formatDateComponents = (d) => {
  // Преобразуем дату в московское время
  const moscowDate = new Date(d.toLocaleString('en-US', { timeZone: 'Europe/Moscow' }));

  return {
    day: String(moscowDate.getDate()).padStart(2, '0'),
    month: String(moscowDate.getMonth() + 1).padStart(2, '0'),
    year: moscowDate.getFullYear(),
    hours: String(moscowDate.getHours()).padStart(2, '0'),
    minutes: String(moscowDate.getMinutes()).padStart(2, '0')
  };
};

// Функция для форматирования даты в формате DD.MM.YYYY (МСК)
export const formatDate = (date) => {
  const d = parseDate(date);
  if (!d) return '-';

  const { day, month, year } = formatDateComponents(d);
  return `${day}.${month}.${year}`;
};

// Функция для форматирования даты и времени в формате DD.MM.YYYY HH:mm (МСК)
export const formatDateTime = (date) => {
  const d = parseDate(date);
  if (!d) return '-';

  const { day, month, year, hours, minutes } = formatDateComponents(d);
  return `${day}.${month}.${year} ${hours}:${minutes}`;
};

// Функция для форматирования относительного времени (например, "5 мин назад") в МСК
export const formatRelativeTime = (date) => {
  if (!date) return '-';

  const d = new Date(date);
  if (isNaN(d.getTime())) return '-';

  // Используем UTC время для правильного расчета разницы
  const now = new Date();
  const diff = now.getTime() - d.getTime();
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 7) {
    return formatDate(date);
  } else if (days > 0) {
    return `${days} дн. назад`;
  } else if (hours > 0) {
    return `${hours} ч. назад`;
  } else if (minutes > 0) {
    return `${minutes} мин. назад`;
  } else {
    return 'Только что';
  }
};